import serviceIcon from "@/assets/images/services/features/sap/service.svg";
import solutionIcon from "@/assets/images/services/features/sap/support.svg";
import supportIcon from "@/assets/images/services/features/sap/support.svg";

import sapAboutImage from "@/assets/images/services/about/sap-about-image.png";

// import dataAnalyticsImage from "@/assets/images/services/services/ai/data-analytics.png";
// import automationImage from "@/assets/images/services/services/ai/intelligent-automation.png";
// import NLPImage from "@/assets/images/services/services/ai/NLP.png";


const sapBusinessOne = {
  "sap-business-one": {
    slug: "sap-business-one",
    name: "Sap Business One",

    
    hero: {
      title: "Power Your Business with SAP - The World's No 1 ERP",
      description:
        "Streamline operations, boost efficiency, and make smarter decisions with SAP solutions implemented by GSUS Star Software"
    },


    features: [
      {
        icon: serviceIcon,
        title: "AI-Powered Data Analytics",
        description:
          "Harness the power of AI to gain deep insights from your data, enabling smarter decisions and improved business outcomes."
      },
      {
        icon: solutionIcon,
        title: "Intelligent Automation",
        description:
          "Automate repetitive tasks with AI-driven solutions that enhance productivity, reduce errors, and free up valuable resources."
      },
      {
        icon: supportIcon,
        title: "Predictive Maintenance",
        description:
          "Utilize AI to predict and prevent equipment failures, reducing downtime and maintenance costs while improving operational efficiency."
      }
    ],

    about: {
      subtitle: "Industries We Serve",
      heading: "We deliver SAP ERP solutions for a variety of industries",
      image: sapAboutImage,
      highlights: [
        "Retail & E-Commerce",
        "Manufacturing & Supply Chain",
        "Wholesale & Distribution",
        "Construction & Real Estate",
        "Service-Based Businesses"
      ]
    },

    // services: {
    //   title: "Transform Your Business with AI-Driven Innovation",
    //   description:
    //     "Empower your business with cutting-edge AI solutions that drive efficiency, automation, and intelligent decision-making. From data analytics to natural language processing, our technologies unlock new opportunities for growth and smarter operations.",
    //   items: [
    //     {
    //       image: dataAnalyticsImage,
    //       name: "AI-Powered Data Analytics",
    //       description:
    //         "Transform your data into actionable insights with our AI-powered analytics solutions. We help you make informed decisions that drive business growth.",
    //       features: [
    //         "Advanced data mining techniques",
    //         "Customized reporting dashboards",
    //         "Real-time data processing",
    //         "Predictive analytics for future trends"
    //       ]
    //     },
    //     {
    //       image: automationImage,
    //       name: "Intelligent Automation",
    //       description:
    //         "Boost productivity and reduce operational costs with our AI-driven automation solutions. We streamline your workflows for maximum efficiency.",
    //       features: [
    //         "Process automation for routine tasks",
    //         "Custom workflows and automation",
    //         "AI-powered decision-making tools",
    //         "Integration with existing systems"
    //       ]
    //     },
    //     {
    //       image: NLPImage,
    //       name: "Natural Language Processing (NLP)",
    //       description:
    //         "Enhance customer experiences with our NLP solutions. We enable seamless communication between humans and machines, improving user interaction and support.",
    //       features: [
    //         "Chatbot development",
    //         "Sentiment analysis",
    //         "Language translation",
    //         "Speech recognition and processing"
    //       ]
    //     }
    //   ]
    // },

    processKpi: {
      heading: "Our Sap Implementation Process",
      steps: [
        {
          number: "01",
          title: "Discovery & Consultation",
          description:
            "We understand your business goals, challenges, and requirements."
        },
        {
          number: "02",
          title: "Solution Planning",
          description:
            "We design a tailored SAP solution aligned with your workflow."
        },
        {
          number: "03",
          title: "Configuration & Customization",
          description:
            "We design a tailored SAP solution aligned with your workflow."
        },
        {
          number: "04",
          title: "Integration",
          description: "Connecting SAP with your existing systems and tools."
        },
        {
          number: "05",
          title: "Training & Onboarding",
          description:
            "Empowering your team to use SAP effectively from day one."
        },
        {
          number: "06",
          title: "Ongoing Support",
          description:
            " 24/7 assistance and continuous improvements for peak performance."
        }
      ]
    },

    expertise: {
      heading: "Why Businesses Trust GSUS Star Software",
      business: [
        {
          description: "Years of experience delivering successful ERP solutions"
        },
        {
          description: "Solutions tailored to your industry and workflow"
        },
        {
          description: "Fast, smooth, and disruption-free SAP deployment"
        },
        {
          description:
            "24/7 assistance to keep your business running at its best"
        }
      ]
    },
    cta: {
      title: "Ready to Transform Your Business?",
      description:
        "Stop struggling with outdated systems. Switch to SAP Solutions by GSUS Star Software and take control of your operations, data, and growth.",
      button: "Book your free consultation now!"
    },

    faq: {
      items: [
        {
          question:
            "What is SAP and why does my business need it?",
          answer:
            "SAP is the world’s leading ERP (Enterprise Resource Planning) system that integrates finance, sales, inventory, HR, and operations into one platform. It helps businesses save time, reduce errors, and make smarter decisions with real-time data."
        },
        {
          question: "Which SAP solution is right for my business?",
          answer:
            "SAP Business One is ideal for small and mid-sized businesses",
        },
        {
          question: "How long does it take to implement SAP?",
          answer:
            "Implementation timelines depend on your company size, processes, and customization needs. On average, small businesses take 2–3 months, while larger enterprises may take 6–12 months. GSUS Star Software ensures fast, smooth, and disruption-free delivery."
        },
        {
          question: "Do you provide training and support after implementation?",
          answer:
            "Yes, We provide end-to-end training to your team and offer 24/7 expert support to ensure your SAP system runs smoothly at all times."
        },
        {
          question: "Can SAP grow with my business?",
          answer:
            "Absolutely. SAP solutions are highly scalable, meaning you can start small and expand as your business grows — without changing systems."
        },
        {
          question: "Why choose GSUS Star Software as my SAP partner?",
          answer:
            " Because we’re a Gold Partner with proven expertise. We specialize in custom implementations, seamless integrations, and continuous support — ensuring SAP works exactly the way your business needs."
        }
      ]
    }
  }
};
export default sapBusinessOne;
